import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconTablet(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path fill="currentColor" d="M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M3 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Zm2 0h14v1H5V3Zm0 3v9h14V6H5Zm0 15v-4h14v4H5Z"
      />
    </BaseIcon>
  );
}
